export const FABRIC_CARD_IMAGE_OPTS = {
  width: 560,
  height: 420,
  crop: 'center',
  format: 'webp'
};

export const FABRIC_GALLERY_IMAGE_OPTS = {
  width: 900,
  format: 'webp'
};

const SHOPIFY_CDN_HOSTS = new Set(['cdn.shopify.com']);

function isShopifyCdnUrl(parsed) {
  if (SHOPIFY_CDN_HOSTS.has(parsed.hostname)) return true;
  if (parsed.hostname.endsWith('.shopifycdn.com')) return true;
  return parsed.pathname.includes('/cdn/shop/');
}

export function optimizeFabricImageUrl(url, options = FABRIC_CARD_IMAGE_OPTS) {
  if (!url) return url;

  try {
    const parsed = new URL(url);
    if (!isShopifyCdnUrl(parsed)) return url;

    if (options.width) parsed.searchParams.set('width', String(options.width));
    if (options.height) parsed.searchParams.set('height', String(options.height));
    if (options.crop) parsed.searchParams.set('crop', options.crop);
    if (options.format) parsed.searchParams.set('format', options.format);

    return parsed.toString();
  } catch {
    return url;
  }
}

export function optimizeFabricImageList(urls, options = FABRIC_CARD_IMAGE_OPTS) {
  return (urls || []).map((url) => optimizeFabricImageUrl(url, options));
}

export function preloadFabricImages(urls, options = FABRIC_GALLERY_IMAGE_OPTS) {
  (urls || []).forEach((url) => {
    const optimized = optimizeFabricImageUrl(url, options);
    const img = new Image();
    img.decoding = 'async';
    img.src = optimized;
  });
}
